import { render, staticRenderFns } from "./plateManage.vue?vue&type=template&id=46135bfd&"
import script from "./plateManage.vue?vue&type=script&lang=js&"
export * from "./plateManage.vue?vue&type=script&lang=js&"
import style0 from "./plateManage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports